"use client";

import RouterLink from "@/components/ui/router-link";
import IndeterminateCheckbox from "../IndeterminateCheckbox";
import { Row } from "@tanstack/react-table";
import Datasheet from "../Datasheet";
export interface DirectusFile {
  id: string;
  title: string;
  filename_download: string;
}

export default function ProductDisplay<T>({
  data,
  row,
}: {
  data: {
    material_number: string;
    slug: string;
    is_new_product: boolean;
    datasheet1_file: DirectusFile | null;
    datasheet2_file: DirectusFile | null;
    datasheet3_file: DirectusFile | null;
  };
  row: Row<T>;
}) {
  const datasheet = [
    data.datasheet1_file,
    data.datasheet2_file,
    data.datasheet3_file,
  ];

  return (
    <div className="flex space-x-3 text-sm">
      <div>
        <IndeterminateCheckbox
          {...{
            checked: row.getIsSelected(),
            disabled: !row.getCanSelect(),
            indeterminate: row.getIsSomeSelected(),
            onChange: row.getToggleSelectedHandler(),
          }}
        />
      </div>
      <div className="-mt-0.5 flex flex-col">
        <div className="mb-1 flex items-center">
          <RouterLink
            className="md:text-base text-sm font-semibold text-[#007c8c] hover:text-[#007c8c] hover:underline"
            href={`/product/${data.slug}`}>
            {data.material_number}
          </RouterLink>

          {data.is_new_product && (
            <div className="md:ml-2 ml-1 text-xs text-primary">NEW</div>
          )}
        </div>

        {datasheet.filter(Boolean).length > 0 && (
          <Datasheet datasheet={datasheet} name={data.material_number} />
        )}
      </div>
    </div>
  );
}
